import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/components/Home')
    },
    {
      path: '/over-de-tool',
      name: 'about_tool',
      component: () => import('@/components/AboutTool')
    }, {
      path: '/faq',
      name: 'faq',
      component: () => import('@/components/Faq')
    },
    {
      path: '/over-ons',
      name: 'about_us',
      component: () => import('@/components/AboutUs')
    },
    {
      path: '/vragenlijst-afgerond',
      name: 'question_list_complete',
      component: () => import('@/components/QuestionListComplete')
    },
    {
      path: '/vragenlijst/:intake_id/:token',
      name: 'question_list',
      component: () => import('@/components/QuestionList')
    },
    // {
    //   path: '/checkout',
    //   name: 'checkout',
    //   component: () => import('@/components/checkout/Checkout')
    // },
    // {
    //   path: '/order-bevestiging',
    //   name: 'order_confirmation',
    //   component: () => import('@/components/checkout/OrderConfirmation')
    // },
    {
      path: '/cookie-verklaring',
      name: 'cookie_statement',
      component: () => import('@/components/CookieStatement')
    },
    {
      path: '/test',
      name: 'test',
      component: () => import('@/components/Vragen')
    },

    {
      path: '/404',
      name: 'not_found',
      component: () => import('@/components/NotFound')
    },
    {
      path: '*',
      redirect: '/404'
    },
  ]
})
